
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.65 8.35l-2.79 2.79a.5.5 0 00.35.86H18a6 6 0 01-8.25 5.56.961.961 0 00-1.04.23 1 1 0 00.34 1.64A7.83 7.83 0 0012 20a8 8 0 008-8h1.79a.5.5 0 00.35-.85l-2.79-2.79a.492.492 0 00-.7-.01zM6 12a6 6 0 018.25-5.56.96.96 0 001.04-.23 1 1 0 00-.34-1.64A7.828 7.828 0 0012 4a8 8 0 00-8 8H2.21a.5.5 0 00-.35.85l2.79 2.79a.5.5 0 00.71 0l2.79-2.79a.5.5 0 00-.36-.85H6z"}})])
          )
        }
      }
    